"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommissionSettlement = void 0;
class CommissionSettlement {
}
exports.CommissionSettlement = CommissionSettlement;
//# sourceMappingURL=host-agency-commission-settlement.model.js.map